export const PhysicalShippingMethods = Object.freeze({
  UPS_GROUND: {
    shippingMethod: 'UPS Ground',
    physicalMethod: 'upsground',
    carrier: 'UPS',
    fulfillmentServiceProvider: 'FISERV',
    category: 'STANDARD_SHIPPING'
  },
  UPS_GROUND_SIGNATURE: {
    shippingMethod: 'UPS Ground wSignature',
    physicalMethod: 'upsgroundsignature',
    carrier: 'UPS',
    fulfillmentServiceProvider: 'FISERV',
    category: null
  },
  UPS_SECOND_DAY: {
    shippingMethod: 'UPS 2nd Day',
    physicalMethod: 'ups2ndday',
    carrier: 'UPS',
    fulfillmentServiceProvider: 'FISERV',
    category: null
  },
  UPS_SECOND_DAY_SIGNATURE: {
    shippingMethod: 'UPS 2nd Day wSignature',
    physicalMethod: 'ups2nddaysignature',
    carrier: 'UPS',
    fulfillmentServiceProvider: 'FISERV',
    category: null
  },
  UPS_NEXT_DAY: {
    shippingMethod: 'UPS Next Day',
    physicalMethod: 'upsnextday',
    carrier: 'UPS',
    fulfillmentServiceProvider: 'FISERV',
    category: null
  },
  UPS_NEXT_DAY_SIGNATURE: {
    shippingMethod: 'UPS Next Day wSignature',
    physicalMethod: 'upsnextdaysignature',
    carrier: 'UPS',
    fulfillmentServiceProvider: 'FISERV',
    category: null
  },
  USPS_PRIORITY: {
    shippingMethod: 'USPS Priority Mail Flat',
    physicalMethod: 'uspspriority',
    carrier: 'USPS',
    fulfillmentServiceProvider: 'FISERV',
    category: null
  },
  USPS_PRIORITY_SIGNATURE: {
    shippingMethod: 'USPS Priority Mail Flat wSignature',
    physicalMethod: 'uspsprioritysig',
    carrier: 'USPS',
    fulfillmentServiceProvider: 'FISERV',
    category: null
  }
})
